import jQuery from 'jquery';
import 'select2';

var tools = {
    initSelect2: function (dom, options = {}) {
        var result;
        if (dom) {
            if (dom instanceof Element) {
                if (dom.tagName === 'SELECT')
                    result = this.initSelect2Element(dom, options);
                else
                    result = this.initSelect2Default(dom, options);
            }
            if (dom instanceof NodeList) {
                result = this.initSelect2NodeList(dom, options);
            }
        } else {
            result = this.initSelect2Default();
        }
        return result;
    },
    initSelect2Default: function (dom = document, options = {}) {
        if (typeof dom.querySelectorAll === 'function')
            return this.initSelect2NodeList(dom.querySelectorAll('select.select2'), options);
        else
            return;
    },
    initSelect2Element: function (dom, options = {}) {
        if (!(dom instanceof Element)) return;
        var default_options = {
            tags: dom.classList.contains('tags'),
            width: dom.classList.contains('w-100') ? '100%' : 'resolve',
            placeholder: dom.hasAttribute('placeholder') ? dom.getAttribute('placeholder') : null
        };
        return jQuery(dom).select2(Object.assign({}, default_options, options));
    },
    initSelect2NodeList: function (doms, options = {}) {
        if (!(doms instanceof NodeList)) return;
        let result = [];
        doms.forEach(dom => result.push(this.initSelect2Element(dom, options)));
        return result;
    }
};

export default tools;

export const initSelect2 = tools.initSelect2;
